import React from 'react';

import Logo from "./../Logo/Logo";
import "./Nav.scss";

function Nav () {
  return (
    <header className="Nav glass">

      <nav>
        <div className="block">

        </div>
      </nav> 
      <div className="dummy">
        <div className="block">
          <Logo />
        </div>
      </div>
    </header>
  );
}

export default Nav;